import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { AppState } from '../../../../app.reducers';
import { getSelectedFiscalYear } from '../../../property/property-store/property.selectors';
import { FiscalYear } from 'app/internal/shared/models';

@Component({
  selector: 'sp-dashboard-past',
  templateUrl: './dashboard-past.component.html',
  styleUrls: ['./dashboard-past.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DashboardPastComponent {
  selectedFiscalYear$: Observable<FiscalYear>;

  ngOnDestroy$ = new Subject();

  constructor(private store: Store<AppState>) {
    this.selectedFiscalYear$ = this.store.pipe(select(getSelectedFiscalYear));
  }
}
